import { useContext } from "react";
import {
  checkoutStripeCustomerPortal,
  checkoutStripeSession,
} from "../services/stripeService";
import useGetValidAccessToken from "./useGetValidAccessToken";
import { UserDetailsContext } from "../contexts";
import { toast } from "react-toastify";

interface ReturnType {
  getCustomerPortalLink: () => Promise<void>;
  getCustomerCheckoutLink: (subscriptionPlan: string) => Promise<void>;
}

export const useGetCustomerPortalLink = (): ReturnType => {
  const { stripeCustomerId } = useContext(UserDetailsContext);
  const { getValidAccessToken } = useGetValidAccessToken();

  const getCustomerPortalLink = async () => {
    if (!stripeCustomerId) return;
    try {
      const accessToken = await getValidAccessToken();
      await checkoutStripeCustomerPortal(stripeCustomerId, accessToken);
    } catch {
      toast.error("Unable to retrieve customer portal link");
    }
  };
  const getCustomerCheckoutLink = async (subcriptionPlan: string) => {
    if (!stripeCustomerId) return;
    try {
      const accessToken = await getValidAccessToken();
      await checkoutStripeSession(
        stripeCustomerId,
        accessToken,
        subcriptionPlan
      );
    } catch {
      toast.error("Unable to retrieve customer portal link");
    }
  };

  return { getCustomerPortalLink, getCustomerCheckoutLink };
};
